import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ExpSummaryElementOptionsFactory;
/* eslint-disable */
/**
 * Expression Service
 * An API for Expression services, supporting the Expression Editor and Expression Evaluation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech) (v6.0.1).
 *
 * Do not edit the class manually.
 */

// InputSpec (yaml) file: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/openapi/internal/typescript/target/openapi/openapi//abwebinternal/expressionservice.yaml
// Template file: models.mustache (typescript-fetch)

/**
 * 
 * @export
 * @interface ExpSummaryElementOptions
 */

export class ExpSummaryElementOptionsFactory {}
_ExpSummaryElementOptionsFactory = ExpSummaryElementOptionsFactory;
_defineProperty(ExpSummaryElementOptionsFactory, "FromJSON", function (json) {
  return _ExpSummaryElementOptionsFactory.FromJSONTyped(json, false);
});
_defineProperty(ExpSummaryElementOptionsFactory, "FromJSONTyped", function (json, ignoreDiscriminator) {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    'textValue': json['textValue'],
    'startsNewLine': json['startsNewLine'],
    'indentLevel': json['indentLevel'],
    'noRichValue': json['noRichValue'],
    'cssClassName': json['cssClassName'],
    'use1000Separator': json['use1000Separator'],
    'asPercentage': json['asPercentage']
  };
});
_defineProperty(ExpSummaryElementOptionsFactory, "ToJSON", function (value) {
  return _ExpSummaryElementOptionsFactory.ToJSONTyped(false, value);
});
_defineProperty(ExpSummaryElementOptionsFactory, "ToJSONTyped", function (ignoreDiscriminator, value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    'textValue': value.textValue,
    'startsNewLine': value.startsNewLine,
    'indentLevel': value.indentLevel,
    'noRichValue': value.noRichValue,
    'cssClassName': value.cssClassName,
    'use1000Separator': value.use1000Separator,
    'asPercentage': value.asPercentage
  };
});
//# sourceMappingURL=ExpSummaryElementOptions.js.map
